import { useCallback } from 'react';
import useCarouselContext from 'components/shared/Carousel/CarouselContext';
import useCarouselIsPlaying from 'hooks/useCarouselIsPlaying';
import { cn } from 'utils/styles';
import PlayIcon from 'public/icons/button-play.svg';
import PauseIcon from 'public/icons/button-pause.svg';

const AutoplayToggleButton = () => {
  const { api } = useCarouselContext();
  const { isPlaying } = useCarouselIsPlaying(api);

  const toggleAutoplay = useCallback(() => {
    const autoplay = api?.plugins()?.autoplay;
    if (!autoplay) return;

    const playOrStop = isPlaying ? autoplay.stop : autoplay.play;
    playOrStop();
  }, [api, isPlaying]);

  const Icon = isPlaying ? PauseIcon : PlayIcon;
  const buttonText = isPlaying ? 'Pause carousel' : 'Play carousel';

  return (
    <button
      className={'cursor-pointer h-8 w-8 bg-(--pagination-arrow) rounded-full flex items-center justify-center'}
      onClick={toggleAutoplay}>
      <Icon className={cn('h-5/12 w-5/12 text-content-inverse')} />
      <span className="sr-only">{buttonText}</span>
    </button>
  );
};

export default AutoplayToggleButton;
